import { getFormatter, Message, MessageSeverity } from '@eih-netbroker/common';
import { JSX, useCallback, useState } from 'react';
import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/checkbox-circle-fill.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error-warning-fill.svg';
import { ReactComponent as InfoRoundedIcon } from '../../../assets/icons/information-fill.svg';
import classes from './MessageCenterListRow.module.scss';

interface MessageCenterListRowProps {
  message: Message;
  onMessageClick: (message: Message) => void;
}

const icons: { [key in MessageSeverity]: JSX.Element } = {
  [MessageSeverity.Info]: (
    <InfoRoundedIcon
      fontSize="inherit"
      className={classes.infoIcon}
    />
  ),
  [MessageSeverity.Warning]: (
    <ErrorIcon
      fontSize="inherit"
      className={classes.warningIcon}
    />
  ),
  [MessageSeverity.Error]: (
    <ErrorIcon
      fontSize="inherit"
      className={classes.errorIcon}
    />
  ),
  [MessageSeverity.Success]: (
    <CheckCircleIcon
      fontSize="inherit"
      className={classes.successIcon}
    />
  ),
};

export const MessageCenterListRow = ({ message, onMessageClick }: MessageCenterListRowProps) => {
  const { formatDateTime } = getFormatter();
  const [isOpened, _setIsOpened] = useState<boolean>(false);

  const body = message.body.split(new RegExp('\\r\\n', 'g'));

  const handleOnMessageClick = useCallback(() => {
    onMessageClick(message);
  }, [message, onMessageClick]);

  return (
    <li
      onClick={handleOnMessageClick}
      className={`${classes.listRow} ${isOpened ? classes.listRowIsOpened : ''}`}
      // onClick={() => {
      //   setIsOpened(!isOpened && !!message.message);
      // }}
    >
      {icons[message.severity]}
      <div className={classes.listRowContent}>
        <span className={`${classes.listRowTitle} ${message.isRead ? classes.listRowTitleIsRead : ''}`}>
          {body.map(line => (
            <span key={line}>
              {line}
              <br />
            </span>
          ))}
          {/* {!!message.message && (
            <MoreHorizIcon
              className={classes.listRowTitleMore}
              fontSize="inherit"
            />
          )} */}
        </span>
        {/* {!!message.message && (
          <Collapse in={isOpened}>
            <span className={classes.listRowMessage}>{message.body}</span>
          </Collapse>
        )} */}
      </div>

      <span className={classes.listRowDate}>{formatDateTime(new Date(message.createdAt))}</span>
      <div className={`${classes.readIndicator} ${message.isRead ? classes.readIndicatorIsRead : ''}`} />
    </li>
  );
};
